import styled from 'styled-components';
import colors from '../../assets/styles/colors';

export const ModalDigitalDocumentsContainer = styled.div`
  position: absolute;
  top: 0;
  right: 0;
  left: 0;
  bottom: 0;
  background: ${colors.bgOverlay};
  z-index: 99;
  display: flex;
  align-items: center;
  justify-content: center;
  transition: .2s;
  opacity: ${prop => prop.open ? '1' : '0'};
  height: ${prop => prop.open ? 'auto' : '0'};
  overflow: ${prop => prop.open ? '' : 'hidden'};
`;

export const ModalDigitalDocumentsContent = styled.div`
  width: 100%;
  max-width: 650px;
  background: ${colors.white};
  box-shadow: 0px 5px 10px ${colors.shadow};
  -webkit-box-shadow: 0px 5px 10px ${colors.shadow};
  -moz-box-shadow: 0px 5px 10px ${colors.shadow};
  border-radius: 16px;
  padding: 20px;
  display: flex;
  flex-direction: column;
  justify-content: center;
`;

export const ModalDigitalDocumentsHead = styled.div`
  display: flex;
  justify-content: flex-end;
  margin-top: ${prop => prop.setShowModal ? '0' : '30px'};

  svg {
    cursor: pointer;
  }
`;

export const ModalDigitalDocumentsBody = styled.div`
  padding: 0 60px;
  display: flex;
  flex-direction: column;
  justify-content: center;
`;

export const ModalDigitalDocumentsFooter = styled.div`
  margin: 30px auto;
`;

export const ModalDigitalDocumentsTitle = styled.p`
  font-weight: bold;
  font-size: 14px;
  line-height: 20px;
  color: ${colors.textPrimary};
  margin-top: 20px;
  margin-bottom: 20px;
  text-align: center;
`;

export const ModalDigitalDocumentsIconContent = styled.div`
  display: grid;
  grid-template-columns: 48px 1fr;
  column-gap: 20px;
  margin-top: 30px;
  align-items: center;
`;

export const ModalDigitalDocumentsIcon = styled.div`
  display: flex;
  width: 48px;
  height: 48px;
  align-items: center;
  justify-content: center;
  background: ${prop => prop.background};
  border-radius: 22px;
`;
